var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _radialGradient, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Folder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Om5yvFr6YrdlC0q2Vet0Ha",
    x1: -7.018,
    x2: 39.387,
    y1: 9.308,
    y2: 33.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fac017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#e1ab2d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Om5yvFr6YrdlC0q2Vet0Ha)",
    d: "M44.5,41h-41C2.119,41,1,39.881,1,38.5v-31C1,6.119,2.119,5,3.5,5h11.597 c1.519,0,2.955,0.69,3.904,1.877L21.5,10h23c1.381,0,2.5,1.119,2.5,2.5v26C47,39.881,45.881,41,44.5,41z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Om5yvFr6YrdlC0q2Vet0Hb",
    x1: 5.851,
    x2: 18.601,
    y1: 9.254,
    y2: 27.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfef3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#e2e4e3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Om5yvFr6YrdlC0q2Vet0Hb)",
    d: "M2,25h20V11H4c-1.105,0-2,0.895-2,2V25z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Om5yvFr6YrdlC0q2Vet0Hc",
    x1: 2,
    x2: 22,
    y1: 19,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfef3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#e2e4e3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Om5yvFr6YrdlC0q2Vet0Hc)",
    d: "M2,26h20V12H4c-1.105,0-2,0.895-2,2V26z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Om5yvFr6YrdlC0q2Vet0Hd",
    x1: 16.865,
    x2: 44.965,
    y1: 39.287,
    y2: 39.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3a917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#d79c1e"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Om5yvFr6YrdlC0q2Vet0Hd)",
    d: "M1,37.875V38.5C1,39.881,2.119,41,3.5,41h41c1.381,0,2.5-1.119,2.5-2.5v-0.625H1z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Om5yvFr6YrdlC0q2Vet0He",
    x1: -4.879,
    x2: 35.968,
    y1: 12.764,
    y2: 30.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ffefb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#ffedad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#ffe99f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#fee289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed86b"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Om5yvFr6YrdlC0q2Vet0He)",
    d: "M44.5,11h-23l-1.237,0.824C19.114,12.591,17.763,13,16.381,13H3.5C2.119,13,1,14.119,1,15.5 v22C1,38.881,2.119,40,3.5,40h41c1.381,0,2.5-1.119,2.5-2.5v-24C47,12.119,45.881,11,44.5,11z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Om5yvFr6YrdlC0q2Vet0Hf",
    cx: 37.836,
    cy: 49.317,
    r: 53.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#fec832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#fcd667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fdda75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#fee496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe8a2"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Om5yvFr6YrdlC0q2Vet0Hf)",
    d: "M44.5,40h-41C2.119,40,1,38.881,1,37.5v-21C1,15.119,2.119,14,3.5,14h13.256 c1.382,0,2.733-0.409,3.883-1.176L21.875,12H44.5c1.381,0,2.5,1.119,2.5,2.5v23C47,38.881,45.881,40,44.5,40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Folder);
export default __webpack_public_path__ + "static/media/icons8-folder.155294693d9b62616a67983cb45438bc.svg";
export { ForwardRef as ReactComponent };